export default "__VITE_ASSET__ddde6005__"